module.exports = __webpack_public_path__ + "img/part5-6.534a7f50.png";